import axios from '@/utils/requset'

const api = {
  getNewsDynamicList: '/client/home/getNewsDynamicList',
  getNewsDynamic: '/client/home/getNewsDynamic',
}

export default {
  getNewsDynamicList(parameter) {
    return axios({
      url: api.getNewsDynamicList,
      method: 'get',
      params: parameter
    })
  },
  getNewsDynamic(parameter) {
    return axios({
      url: api.getNewsDynamic,
      method: 'get',
      params: parameter
    })
  },
}
